var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar"},[_c('Avatar',{staticClass:"avatar__photo",attrs:{"src":_vm.user.getPhotoUrl()}}),_c('p',{staticClass:"avatar__name subtitle-1"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }